/**
 * Feature flag for the Painel de Governança de Benefícios.
 *
 * GrowthBook is not yet installed in this repo (tracked in P1-impl Phase 7).
 * For P1 pilot, we gate the painel behind an env var that lists allow-listed
 * organization IDs. The flag evaluates client-side from the authenticated
 * user's organization. Anything not explicitly listed falls through to the
 * "coming soon" placeholder rendered by the page.
 *
 * Replace this with a GrowthBook call when Phase 7 wires the SDK.
 */

interface IAuthUser {
  isAdmin?: boolean
  organization?: { id?: string; cnpj?: string } | null
}

const PILOT_ORG_IDS: string[] = (import.meta.env.VITE_GOVERNANCE_PILOT_ORG_IDS as string | undefined)
  ?.split(',')
  .map(s => s.trim())
  .filter(Boolean) ?? []

export function isGovernanceEnabled(user: IAuthUser | null | undefined): boolean {
  if (!user) return false
  // Admins always see the painel (internal rollout + QA).
  if (user.isAdmin) return true
  const orgId = user.organization?.id
  if (!orgId) return false
  return PILOT_ORG_IDS.includes(orgId)
}
